import React, { useRef, useState, useEffect, useContext } from "react";
import { ThemeContext } from 'styled-components';
import * as S from "./FlorenzButton.style.js";
import { ZaiaImage } from "../../zaiaComponents/zaiaImage/ZaiaImage.style.js";

const defaultDoctor = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaImgDefault/default-doctor.png`;

function FlorenzButton({ 
  size='m',
  text,
  type,
  typeStyle,
  disabled,
  icon,
  iconSize,
  onClick,
  widthComplete
}) {  

  // types
  // primary, secondary, secondaryWhite, success, outline

  return (
    <S.FlorenzButton 
      $size={size}
      $typeStyle={typeStyle}
      $disabled={disabled}
      $iconSize={iconSize}
      $widthComplete={widthComplete}
      $text={text}
    >
      <button className="button"
        onClick={() => {(!disabled && onClick) && onClick()}}
        type={type}
      >
        {
          text &&
          <div className="button__text">{text}</div>
        }
        {
          icon &&
          <div className={`button__icon`}>
            <i className={`icon ${icon}`}></i>
          </div>
        }
        {
          disabled &&
          <div className="button__disabled">
            <i className="icon icon-disabled"></i>
          </div>
        }
      </button>
    </S.FlorenzButton>
  );
}

export default FlorenzButton;
